import React, { useState } from "react";
import "../../Styles/NotesFollowUpForm.css";

const AdminNotesFollowUpForm = () => {
  const [formData, setFormData] = useState({
    subject: "",
    person: "",
    voterId:"",
    mobile: "",
    category: "",
    priority: "",
    dueDate: "",
    village: "",
    mandal: "",
    status: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="note-form-container">
      <div className="note-form-card">
        <div className="note-form-header">
          <h2>Add New Note / Follow Up</h2>
          <p>Track pending actions, reminders, and constituent follow-ups</p>
          <button
            className="note-back-btn"
            onClick={() => window.history.back()}
          >
            Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="note-form-grid">

            <div className="note-form-group note-full-width">
              <label>Subject *</label>
              <input
                type="text"
                name="subject"
                placeholder="Ex: Follow up on drinking water pipeline complaint"
                onChange={handleChange}
              />
            </div>

            <div className="note-form-group">
              <label>Related Person *</label>
              <input
                type="text"
                name="person"
                placeholder="Enter Name"
                onChange={handleChange}
              />
            </div>
             <div className="note-form-group">
              <label>Voter Id *</label>
              <input
                type="text"
                name="voterId"
                placeholder="Enter VoterId"
                onChange={handleChange}
              />
            </div>

            <div className="note-form-group">
              <label>Mobile Number</label>
              <input
                type="tel"
                name="mobile"
                placeholder="Enter Mobile Number"
                maxLength="10"
                onChange={handleChange}
              />
            </div>

            <div className="note-form-group">
              <label>Category *</label>
              <select name="category" onChange={handleChange}>
                <option>Select Category</option>
                <option>Grievance Follow-up</option>
                <option>Scheme Follow-up</option>
                <option>Development Work</option>
                <option>General</option>
              </select>
            </div>

            <div className="note-form-group">
              <label>Priority *</label>
              <select name="priority" onChange={handleChange}>
                <option>Select Priority</option>
                <option>High</option>
                <option>Medium</option>
                <option>Low</option>
              </select>
            </div>

            <div className="note-form-group">
              <label>Due Date *</label>
              <input
                type="date"
                name="dueDate"
                onChange={handleChange}
              />
            </div>

            <div className="note-form-group">
              <label>Status *</label>
              <select name="status" onChange={handleChange}>
                <option>Select Status</option>
                <option>Open</option>
                <option>In Progress</option>
                <option>Completed</option>
              </select>
            </div>

            <div className="note-form-group">
              <label>Village</label>
              <input
                type="text"
                name="village"
                placeholder="Enter Village"
                onChange={handleChange}
              />
            </div>

            <div className="note-form-group">
              <label>Mandal</label>
              <select name="mandal" onChange={handleChange}>
                <option>Select Mandal</option>
                <option>Kandukur</option>
                <option>Gudluru</option>
                <option>Ulavapadu</option>
              </select>
            </div>

          </div>

          <div className="note-form-group note-full-width">
            <label>Notes / Description *</label>
            <textarea
              rows="4"
              name="description"
              placeholder="Enter detailed notes about this follow-up"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="note-btn-group">
            <button type="submit" className="note-submit-btn">
              Submit
            </button>
            <button type="reset" className="note-reset-btn">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminNotesFollowUpForm;